(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('.announcement-bar');
    if (!bar) return;
    var slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    var index = 0;
    var interval = parseInt(bar.dataset.interval, 10) || 5000;
    setInterval(function () {
      slides[index].classList.remove('is-active');
      index = (index + 1) % slides.length;
      slides[index].classList.add('is-active');
    }, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bento-categories"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bento').forEach(function (section) {
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-inview');
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-inview');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="Proof-"]').forEach(function (section) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var animateNumber = function (element) {
      var raw = element.textContent.trim();
      var match = raw.match(/^([\d.,]+)(.*)$/);
      if (!match) return;
      var hasSeparator = /[.,]/.test(match[1]);
      var target = parseInt(match[1].replace(/[.,]/g, ''), 10);
      if (!target || target < 10) return;
      var suffix = match[2] || '';
      var formatter = new Intl.NumberFormat('de-DE');
      var duration = 1400;
      var start = null;
      var step = function (timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = Math.round(target * eased);
        element.textContent = (hasSeparator ? formatter.format(value) : String(value)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };

    var reveal = function () {
      section.classList.add('is-inview');
      if (!reduceMotion) {
        section.querySelectorAll('[data-countup]').forEach(animateNumber);
      }
    };

    if (!('IntersectionObserver' in window)) {
      reveal();
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal();
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var desc = document.getElementById('PlpDescription');
    var readmore = document.getElementById('PlpReadmore');
    if (desc && readmore) {
      readmore.addEventListener('click', function () {
        var collapsed = desc.classList.toggle('is-collapsed');
        readmore.textContent = collapsed ? readmore.dataset.more : readmore.dataset.less;
      });
    }

    var catInput = document.getElementById('CatSearchInput');
    var catResults = document.getElementById('CatSearchResults');
    var catTimer;
    if (catInput && catResults) {
      catInput.addEventListener('input', function () {
        clearTimeout(catTimer);
        var q = catInput.value.trim();
        if (q.length < 2) { catResults.hidden = true; catResults.innerHTML = ''; return; }
        catTimer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=8')
            .then(function (r) { return r.json(); })
            .then(function (data) {
              var cols = (((data || {}).resources || {}).results || {}).collections || [];
              if (cols.length) {
                catResults.innerHTML = cols.map(function (c) { return '<a href="' + c.url + '">' + c.title + '</a>'; }).join('');
              } else {
                catResults.innerHTML = '<span class="plp-catsearch__empty">Keine passende Kategorie – <a href="/search?q=' + encodeURIComponent(q) + '">im ganzen Sortiment suchen</a></span>';
              }
              catResults.hidden = false;
            })
            .catch(function () { catResults.hidden = true; });
        }, 220);
      });
      catInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          var first = catResults.querySelector('a');
          window.location = first ? first.href : '/search?q=' + encodeURIComponent(catInput.value);
        }
      });
      document.addEventListener('click', function (event) {
        if (!event.target.closest('#CatSearch')) catResults.hidden = true;
      });
    }

    var drawer = document.getElementById('FilterDrawer');
    var openBtn = document.getElementById('FilterOpen');
    var closeBtn = document.getElementById('FilterClose');
    if (drawer && openBtn) { openBtn.addEventListener('click', function () { drawer.showModal(); }); }
    if (drawer && closeBtn) { closeBtn.addEventListener('click', function () { drawer.close(); }); }
    if (drawer) {
      drawer.addEventListener('click', function (event) { if (event.target === drawer) drawer.close(); });
    }

    document.querySelectorAll('[data-filter-range]').forEach(function (range) {
      var minRange = range.querySelector('[data-range-min]');
      var maxRange = range.querySelector('[data-range-max]');
      var minNumber = minRange ? document.getElementById(minRange.dataset.numberTarget) : null;
      var maxNumber = maxRange ? document.getElementById(maxRange.dataset.numberTarget) : null;
      if (!minRange || !maxRange || !minNumber || !maxNumber) return;
      var syncTrack = function () {
        var cap = Number(maxRange.max) || 1;
        var minValue = Math.min(Number(minRange.value), Number(maxRange.value));
        var maxValue = Math.max(Number(maxRange.value), Number(minRange.value));
        range.style.setProperty('--range-start', ((minValue / cap) * 100) + '%');
        range.style.setProperty('--range-end', ((maxValue / cap) * 100) + '%');
      };
      var syncFromRanges = function (source) {
        if (Number(minRange.value) > Number(maxRange.value)) {
          if (source === minRange) maxRange.value = minRange.value; else minRange.value = maxRange.value;
        }
        minNumber.value = Number(minRange.value) > 0 ? minRange.value : '';
        maxNumber.value = Number(maxRange.value) < Number(maxRange.max) ? maxRange.value : '';
        syncTrack();
      };
      var syncFromNumbers = function () {
        minRange.value = minNumber.value === '' ? minRange.min : Math.min(Number(minNumber.value), Number(maxRange.max));
        maxRange.value = maxNumber.value === '' ? maxRange.max : Math.max(Number(maxNumber.value), Number(minRange.min));
        if (Number(minRange.value) > Number(maxRange.value)) maxRange.value = minRange.value;
        syncTrack();
      };
      minRange.addEventListener('input', function () { syncFromRanges(minRange); });
      maxRange.addEventListener('input', function () { syncFromRanges(maxRange); });
      minNumber.addEventListener('input', syncFromNumbers);
      maxNumber.addEventListener('input', syncFromNumbers);
      syncTrack();
    });

    document.querySelectorAll('[data-numeric-filter]').forEach(function (wrap) {
      var mode = wrap.dataset.numericFilter;
      var boxes = Array.prototype.slice.call(wrap.querySelectorAll('[data-numeric-values] input[type="checkbox"]'));
      var minRange = wrap.querySelector('[data-nrange-min]');
      var maxRange = wrap.querySelector('[data-nrange-max]');
      var minNumber = wrap.querySelector('[data-numeric-min]');
      var maxNumber = wrap.querySelector('[data-numeric-max]');
      var track = wrap.querySelector('.filter-numeric__range');
      if (!boxes.length || !minRange || !maxRange || !minNumber || !maxNumber) { wrap.classList.add('is-list'); return; }
      var parsed = [];
      var unparseable = 0;
      boxes.forEach(function (box) {
        var labelText = (box.parentElement.textContent || '').replace(/\([^)]*\)\s*$/, '');
        var numbers = labelText.match(/\d+(?:[.,]\d+)?/g);
        if (!numbers || !numbers.length) { unparseable += 1; return; }
        var s = parseFloat(numbers[0].replace(',', '.'));
        var e2 = parseFloat(numbers[numbers.length - 1].replace(',', '.'));
        if (mode === 'cm') e2 = s;
        parsed.push({ box: box, start: Math.min(s, e2), end: Math.max(s, e2) });
      });
      if (!parsed.length || unparseable > parsed.length) { wrap.classList.add('is-list'); return; }
      var globalMin = Math.floor(parsed.reduce(function (m, p) { return Math.min(m, p.start); }, Infinity));
      var globalMax = Math.ceil(parsed.reduce(function (m, p) { return Math.max(m, p.end); }, -Infinity));
      if (!isFinite(globalMin) || !isFinite(globalMax) || globalMin === globalMax) { wrap.classList.add('is-list'); return; }
      minRange.min = globalMin; minRange.max = globalMax; minRange.step = 1;
      maxRange.min = globalMin; maxRange.max = globalMax; maxRange.step = 1;
      var checked = parsed.filter(function (p) { return p.box.checked; });
      var selMin = checked.length ? Math.floor(checked.reduce(function (m, p) { return Math.min(m, p.start); }, Infinity)) : globalMin;
      var selMax = checked.length ? Math.ceil(checked.reduce(function (m, p) { return Math.max(m, p.end); }, -Infinity)) : globalMax;
      minRange.value = selMin; maxRange.value = selMax;
      minNumber.placeholder = globalMin; maxNumber.placeholder = globalMax;
      if (selMin > globalMin) minNumber.value = selMin;
      if (selMax < globalMax) maxNumber.value = selMax;
      var markNarrowed = function () {
        var narrowed = Number(minRange.value) > globalMin || Number(maxRange.value) < globalMax;
        wrap.closest('.filter-group').dataset.narrowed = narrowed ? 'true' : 'false';
      };
      var syncTrack = function () {
        if (!track) return;
        var span = globalMax - globalMin || 1;
        var lo = Math.min(Number(minRange.value), Number(maxRange.value));
        var hi = Math.max(Number(minRange.value), Number(maxRange.value));
        track.style.setProperty('--range-start', (((lo - globalMin) / span) * 100) + '%');
        track.style.setProperty('--range-end', (((hi - globalMin) / span) * 100) + '%');
      };
      var syncFromRanges = function (source) {
        if (Number(minRange.value) > Number(maxRange.value)) {
          if (source === minRange) maxRange.value = minRange.value; else minRange.value = maxRange.value;
        }
        minNumber.value = Number(minRange.value) > globalMin ? minRange.value : '';
        maxNumber.value = Number(maxRange.value) < globalMax ? maxRange.value : '';
        syncTrack(); markNarrowed();
      };
      var syncFromNumbers = function () {
        minRange.value = minNumber.value === '' ? globalMin : Math.max(globalMin, Math.min(Number(minNumber.value), globalMax));
        maxRange.value = maxNumber.value === '' ? globalMax : Math.min(globalMax, Math.max(Number(maxNumber.value), globalMin));
        if (Number(minRange.value) > Number(maxRange.value)) maxRange.value = minRange.value;
        syncTrack(); markNarrowed();
      };
      minRange.addEventListener('input', function () { syncFromRanges(minRange); });
      maxRange.addEventListener('input', function () { syncFromRanges(maxRange); });
      minNumber.addEventListener('input', syncFromNumbers);
      maxNumber.addEventListener('input', syncFromNumbers);
      syncTrack(); markNarrowed();
      var form = wrap.closest('form');
      if (form) {
        form.addEventListener('submit', function () {
          var lo = Number(minRange.value);
          var hi = Number(maxRange.value);
          var fullRange = lo <= globalMin && hi >= globalMax;
          parsed.forEach(function (p) {
            if (p.box.disabled) return;
            p.box.checked = fullRange ? false : (p.end >= lo && p.start <= hi);
          });
        });
      }
    });

    if (drawer) {
      var epochGroup = null;
      var periodGroup = null;
      drawer.querySelectorAll('.filter-group').forEach(function (group) {
        var label = (group.querySelector('summary') || {}).textContent || '';
        if (/epoche/i.test(label)) epochGroup = group;
        if (/jahr|zeitraum/i.test(label)) periodGroup = group;
      });
      var lockGroup = function (group, locked) {
        group.classList.toggle('is-locked', locked);
        group.querySelectorAll('input').forEach(function (input) { if (!input.checked) input.disabled = locked; });
        var note = group.querySelector('.filter-lock-note');
        if (locked && !note) {
          note = document.createElement('p');
          note.className = 'filter-lock-note';
          note.textContent = 'Es kann entweder nach Epoche ODER nach Zeitraum gefiltert werden.';
          group.appendChild(note);
        } else if (!locked && note) { note.remove(); }
      };
      var groupActive = function (group) {
        if (!group) return false;
        if (group.dataset.narrowed === 'true') return true;
        return group.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      };
      var syncLock = function () {
        if (!epochGroup || !periodGroup) return;
        lockGroup(periodGroup, groupActive(epochGroup));
        lockGroup(epochGroup, groupActive(periodGroup));
      };
      if (epochGroup && periodGroup) {
        [epochGroup, periodGroup].forEach(function (group) {
          group.addEventListener('change', syncLock);
          group.addEventListener('input', syncLock);
        });
        syncLock();
      }
    }

    var grid = document.getElementById('ProductGrid');
    var viewButtons = document.querySelectorAll('.plp-view-btn');
    var applyCols = function (cols) {
      if (!grid) return;
      grid.classList.remove('cols-3', 'cols-4');
      grid.classList.add('cols-' + cols);
      viewButtons.forEach(function (b) { b.classList.toggle('is-active', b.dataset.cols === cols); });
      try { localStorage.setItem('vehrs_plp_cols', cols); } catch (e) {}
    };
    var savedCols = null;
    try { savedCols = localStorage.getItem('vehrs_plp_cols'); } catch (e) {}
    applyCols(savedCols === '4' ? '4' : '3');
    viewButtons.forEach(function (btn) { btn.addEventListener('click', function () { applyCols(btn.dataset.cols); }); });

    var wireLoadMore = function () {
      var btn = document.getElementById('LoadMoreBtn');
      if (!btn) return;
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        btn.textContent = 'Lädt …';
        fetch(btn.href)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.getElementById('ProductGrid');
            if (newGrid && grid) {
              while (newGrid.firstElementChild) { grid.appendChild(newGrid.firstElementChild); }
            }
            var count = document.getElementById('PlpCount');
            if (count && grid) { count.textContent = grid.children.length + ' von ' + count.dataset.total + ' Objekten'; }
            var newBtn = doc.getElementById('LoadMoreBtn');
            var wrap = document.getElementById('LoadMoreWrap');
            if (newBtn && wrap) { wrap.innerHTML = ''; wrap.appendChild(newBtn); wireLoadMore(); }
            else if (wrap) { wrap.innerHTML = ''; }
          })
          .catch(function () { window.location.href = btn.href; });
      });
    };
    wireLoadMore();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="Ccta-"]').forEach(function (section) {
    var topic = section.querySelector('[data-ccta-topic]');
    var standard = section.querySelector('[data-ccta-standard]');
    var commission = section.querySelector('[data-ccta-commission]');
    var form = section.querySelector('form');
    var updateFields = function () {
      if (!topic) return;
      var value = topic.value.toLowerCase();
      var isCommission = value.indexOf('kommission') !== -1;
      if (commission) commission.hidden = !isCommission;
      if (standard) {
        standard.hidden = isCommission;
        standard.disabled = isCommission;
      }
      section.querySelectorAll('[data-ccta-group]').forEach(function (group) {
        var isDelivery = group.dataset.cctaGroup === 'delivery' && value.indexOf('lieferung') !== -1;
        var isRestoration = group.dataset.cctaGroup === 'restoration' && (value.indexOf('aufbereitung') !== -1 || value.indexOf('überarbeitung') !== -1);
        var visible = !isCommission && (isDelivery || isRestoration);
        group.querySelectorAll('input, select, textarea').forEach(function (field) {
          field.disabled = !visible;
        });
        group.hidden = !visible;
        group.querySelectorAll('[data-required-when-visible]').forEach(function (field) {
          field.required = visible;
        });
      });
    };
    if (form) {
      form.addEventListener('submit', function (event) {
        if (topic && topic.value.toLowerCase().indexOf('kommission') !== -1) {
          event.preventDefault();
          updateFields();
          commission.querySelector('a').focus();
        }
      });
    }
    if (topic) {
      topic.addEventListener('change', updateFields);
      updateFields();
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-inview');
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-inview');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-editorial-tabs]').forEach(function (section) {
    var tabs = Array.from(section.querySelectorAll('[data-editorial-tab]'));
    var panels = Array.from(section.querySelectorAll('[data-editorial-panel]'));
    if (!tabs.length || !panels.length) return;

    var activate = function (id, focusTab) {
      tabs.forEach(function (tab) {
        var active = tab.dataset.editorialTab === id;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.dataset.editorialPanel === id);
      });
    };

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(tab.dataset.editorialTab, false);
      });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowRight' && event.key !== 'ArrowUp' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var direction = event.key === 'ArrowDown' || event.key === 'ArrowRight' ? 1 : -1;
        var next = (index + direction + tabs.length) % tabs.length;
        activate(tabs[next].dataset.editorialTab, true);
      });
    });

    section.classList.add('is-ready');
    activate(tabs[0].dataset.editorialTab, false);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-collection').forEach(function (section) {
    var scroller = section.querySelector('[data-scroller]');
    if (!scroller) return;
    section.querySelectorAll('.featured-collection__arrow').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.dataset.dir, 10) || 1;
        scroller.scrollBy({ left: dir * scroller.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var searchDialog = document.getElementById('SearchDialog');
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (searchDialog) searchDialog.showModal();
      });
    });
    document.querySelectorAll('[data-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (searchDialog) searchDialog.close();
      });
    });
    if (searchDialog) {
      searchDialog.addEventListener('click', function (event) {
        if (event.target === searchDialog) searchDialog.close();
      });
    }

    var drawer = document.getElementById('MenuDrawer');
    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (drawer) drawer.classList.add('is-open');
      });
    });
    document.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (drawer) drawer.classList.remove('is-open');
      });
    });

    var header = document.querySelector('.header--transparent');
    if (!header) return;
    var updateScrolledState = function () {
      header.classList.toggle('header--scrolled', window.scrollY > 40);
    };
    updateScrolledState();
    window.addEventListener('scroll', updateScrolledState, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-hero-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var hero = btn.closest('.shopify-section') || btn.closest('.hero');
        var target = hero ? hero.nextElementSibling : null;
        if (target && target.scrollIntoView) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          window.scrollBy({ top: window.innerHeight * 0.85, behavior: 'smooth' });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["link-grid"] && !Shopify.designMode) return;
  try {
    
  const lgridCards = document.querySelectorAll('.lgrid__card');
  if ('IntersectionObserver' in window && lgridCards.length) {
    const lgridIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          lgridIo.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });
    lgridCards.forEach((card) => lgridIo.observe(card));
  } else {
    lgridCards.forEach((card) => card.classList.add('is-inview'));
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var stage = document.getElementById('ProductStage');
    var mainImage = document.getElementById('ProductMainImage');
    var thumbnails = Array.prototype.slice.call(document.querySelectorAll('.product__thumbnail'));
    var currentIndex = 0;
    thumbnails.forEach(function (thumb) {
      var preload = new Image();
      preload.src = thumb.dataset.fullSrc;
    });

    var applyRatio = function (ratio) {
      var value = parseFloat(ratio);
      if (stage && value > 0) {
        stage.style.setProperty('--img-ratio', value);
      }
    };

    // Sicherheitsnetz: falls kein Verhaeltnis geliefert wurde, aus dem
    // geladenen Bild selbst bestimmen.
    if (mainImage) {
      var syncFromNatural = function () {
        if (mainImage.naturalWidth && mainImage.naturalHeight) {
          applyRatio(mainImage.naturalWidth / mainImage.naturalHeight);
        }
      };
      if (mainImage.complete) syncFromNatural();
      mainImage.addEventListener('load', syncFromNatural);
    }

    var showImage = function (index) {
      if (!mainImage || !thumbnails.length) return;
      currentIndex = (index + thumbnails.length) % thumbnails.length;
      var thumb = thumbnails[currentIndex];
      applyRatio(thumb.dataset.ratio);
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumb.dataset.fullSrc;
      mainImage.alt = thumb.dataset.fullAlt || '';
      thumbnails.forEach(function (t, i) {
        t.classList.toggle('is-active', i === currentIndex);
      });
      var thumbs = document.getElementById('ProductThumbs');
      if (thumbs) {
        thumbs.scrollTo({
          left: thumb.offsetLeft - (thumbs.clientWidth - thumb.offsetWidth) / 2,
          behavior: 'smooth'
        });
      }
    };

    thumbnails.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        showImage(i);
      });
    });
    var prev = document.getElementById('GalleryPrev');
    var next = document.getElementById('GalleryNext');
    if (prev) prev.addEventListener('click', function (event) {
      event.preventDefault();
      showImage(currentIndex - 1);
    });
    if (next) next.addEventListener('click', function (event) {
      event.preventDefault();
      showImage(currentIndex + 1);
    });

    // Lightbox: grosses Bild-Popup mit Durchschalten (Briefing 28.07.)
    var lightbox = document.getElementById('LightboxDialog');
    var lightboxImage = document.getElementById('LightboxImage');
    var lightboxCounter = document.getElementById('LightboxCounter');
    var imagesData = [];
    try {
      var dataNode = document.getElementById('ProductImagesData');
      imagesData = dataNode ? JSON.parse(dataNode.textContent) : [];
    } catch (e) {
      imagesData = [];
    }
    var lightboxIndex = 0;
    var lightboxShow = function (index) {
      if (!lightbox || !lightboxImage || !imagesData.length) return;
      lightboxIndex = (index + imagesData.length) % imagesData.length;
      lightboxImage.src = imagesData[lightboxIndex].src;
      lightboxImage.alt = imagesData[lightboxIndex].alt || '';
      if (lightboxCounter) {
        lightboxCounter.textContent = imagesData.length > 1 ? (lightboxIndex + 1) + ' / ' + imagesData.length : '';
      }
      lightbox.querySelectorAll('[data-lightbox-prev], [data-lightbox-next]').forEach(function (arrowBtn) {
        arrowBtn.style.display = imagesData.length > 1 ? '' : 'none';
      });
    };
    var lightboxOpen = function (index) {
      if (!lightbox || !imagesData.length) return;
      lightboxShow(index);
      if (!lightbox.open) lightbox.showModal();
    };
    if (mainImage) {
      mainImage.addEventListener('click', function () {
        lightboxOpen(currentIndex);
      });
    }
    document.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        lightboxOpen(currentIndex);
      });
    });
    if (lightbox) {
      lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          lightbox.close();
        });
      });
      lightbox.querySelectorAll('[data-lightbox-prev]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          lightboxShow(lightboxIndex - 1);
        });
      });
      lightbox.querySelectorAll('[data-lightbox-next]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          lightboxShow(lightboxIndex + 1);
        });
      });
      lightbox.addEventListener('click', function (event) {
        if (event.target === lightbox) lightbox.close();
      });
      lightbox.addEventListener('close', function () {
        if (thumbnails.length) showImage(lightboxIndex);
      });
      document.addEventListener('keydown', function (event) {
        if (!lightbox.open) return;
        if (event.key === 'ArrowLeft') lightboxShow(lightboxIndex - 1);
        if (event.key === 'ArrowRight') lightboxShow(lightboxIndex + 1);
      });
      var touchStartX = null;
      lightbox.addEventListener('touchstart', function (event) {
        touchStartX = event.changedTouches[0].clientX;
      }, { passive: true });
      lightbox.addEventListener('touchend', function (event) {
        if (touchStartX === null) return;
        var delta = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(delta) > 40) {
          if (delta > 0) lightboxShow(lightboxIndex - 1);
          else lightboxShow(lightboxIndex + 1);
        }
        touchStartX = null;
      }, { passive: true });
    }

    var share = document.getElementById('ShareButton');
    if (share) {
      share.addEventListener('click', function () {
        var url = share.dataset.url;
        var done = function () {
          var label = share.querySelector('span');
          if (label) {
            var original = label.textContent;
            label.textContent = share.dataset.copied;
            setTimeout(function () { label.textContent = original; }, 2000);
          }
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done);
        } else {
          done();
        }
      });
    }

    // Anfrage-Dialog (Briefing: Popup im Vordergrund)
    var askDialog = document.getElementById('AskDialog');
    var askTopic = document.getElementById('AskTopic');
    var updateAskFields = function () {
      if (!askDialog || !askTopic) return;
      var value = askTopic.value.toLowerCase();
      askDialog.querySelectorAll('[data-ask-group]').forEach(function (group) {
        var isDelivery = group.dataset.askGroup === 'delivery' && value.indexOf('lieferung') !== -1;
        var isRestoration = group.dataset.askGroup === 'restoration' && (value.indexOf('aufbereitung') !== -1 || value.indexOf('überarbeitung') !== -1);
        var visible = isDelivery || isRestoration;
        group.hidden = !visible;
        group.querySelectorAll('[data-required-when-visible]').forEach(function (field) {
          field.required = visible;
        });
      });
    };
    if (askTopic) askTopic.addEventListener('change', updateAskFields);

    document.querySelectorAll('[data-ask]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!askDialog) return;
        if (askTopic && btn.dataset.ask) {
          for (var i = 0; i < askTopic.options.length; i++) {
            if (askTopic.options[i].text.indexOf(btn.dataset.ask) === 0 || btn.dataset.ask.indexOf(askTopic.options[i].text) === 0) {
              askTopic.selectedIndex = i;
              break;
            }
          }
        }
        updateAskFields();
        askDialog.showModal();
      });
    });
    document.querySelectorAll('[data-ask-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (askDialog) askDialog.close();
      });
    });
    if (askDialog) {
      askDialog.addEventListener('click', function (event) {
        if (event.target === askDialog) askDialog.close();
      });
    }

    var phoneDialog = document.getElementById('PhoneDialog');
    document.querySelectorAll('[data-phone-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (phoneDialog) phoneDialog.showModal();
      });
    });
    document.querySelectorAll('[data-phone-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (phoneDialog) phoneDialog.close();
      });
    });
    if (phoneDialog) {
      phoneDialog.addEventListener('click', function (event) {
        if (event.target === phoneDialog) phoneDialog.close();
      });
    }

    var infoBox = document.getElementById('ProductInfo');
    var stickyBar = document.getElementById('StickyBar');
    if (!infoBox || !stickyBar || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '-120px 0px 0px 0px' }
    );
    observer.observe(infoBox);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["room-links"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="Rooms-"]').forEach(function (section) {
    var links = section.querySelectorAll('[data-room-link]');
    var images = section.querySelectorAll('[data-room-image]');
    if (!links.length) return;

    var activate = function (index) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link.dataset.roomLink === String(index));
      });
      images.forEach(function (image) {
        image.classList.toggle('is-active', image.dataset.roomImage === String(index));
      });
    };

    links.forEach(function (link) {
      ['mouseenter', 'focus'].forEach(function (eventName) {
        link.addEventListener(eventName, function () {
          activate(link.dataset.roomLink);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-cards"] && !Shopify.designMode) return;
  try {
    
  const svcCards = document.querySelectorAll('.svc-card');
  if ('IntersectionObserver' in window && svcCards.length) {
    const svcIo = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          svcIo.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    svcCards.forEach((card) => svcIo.observe(card));
  } else {
    svcCards.forEach((card) => card.classList.add('is-inview'));
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="Stl-"]').forEach(function (section) {
    var spots = section.querySelectorAll('.stl__spot');

    var closeAll = function (except) {
      spots.forEach(function (spot) {
        if (spot !== except) {
          spot.classList.remove('is-open');
          var dot = spot.querySelector('[data-stl-toggle]');
          if (dot) dot.setAttribute('aria-expanded', 'false');
        }
      });
    };

    spots.forEach(function (spot) {
      var dot = spot.querySelector('[data-stl-toggle]');
      if (!dot) return;
      dot.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = spot.classList.toggle('is-open');
        dot.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        closeAll(spot);
      });
    });

    document.addEventListener('click', function (event) {
      if (!section.contains(event.target)) {
        closeAll(null);
        return;
      }
      if (!event.target.closest('.stl__spot')) closeAll(null);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAll(null);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="Usp-"]').forEach(function (section) {
    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-inview');
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            section.classList.add('is-inview');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );
    observer.observe(section);
  });

  } catch(e) { console.error(e); }
})();
})();
